import { getStatusContent } from './statusContent';
import StatusIconBadge from './StatusIconBadge';
import type { RegistrationStatusProps } from './types';

/**
 * Person-centric status headline — the shared "did I get in?" answer used on the
 * manage page and the post-signup confirmation. Renders an icon, the one-sentence
 * headline, and a supporting line, all sourced from `getStatusContent`.
 */
export default function StatusMessage(props: RegistrationStatusProps) {
  const content = getStatusContent(props);
  if (!content.headline) return null;

  return (
    <div>
      <StatusIconBadge
        tone={content.tone}
        icon={content.icon}
        waitlistPosition={props.waitlist_position}
        className="pop mx-auto"
      />
      <h3 className="mt-4 text-2xl font-extrabold tracking-tight text-gray-900 dark:text-white">
        {content.headline}
      </h3>
      <p className="mt-1.5 text-sm text-gray-500 dark:text-gray-400">{content.subtext}</p>
    </div>
  );
}
